import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'

export default {
  setStep({ commit }, value) {
    commit(types.SET_STEP, value)
    commit(types.SET_VISITED_STEP, value)
  },
  setDelimiter({ commit }, value) {
    commit(types.SET_DELIMITER, value)
  },
  resetVisitedStep({ commit }, value) {
    commit(types.RESET_VISITED_STEP, value)
  },
  setCorporateId({ commit }, value) {
    commit(types.SET_CORPORATE_ID, value)
  },
  setSchemaName({ commit }, value) {
    commit(types.SET_SCHEMA_NAME, value)
  },
  setMappedData({ commit }, value) {
    commit(types.SET_MAPPED_DATA, value)
  },
  setTemplateName({ commit }, value) {
    commit(types.SET_TEMPLATE_NAME, value)
  },
  setIsSkipChecked({ commit }, value) {
    commit(types.SET_IS_SKIP_CHECKED, value)
  },
  setRowsToSkip({ commit }, value) {
    commit(types.SET_ROWS_TO_SKIP, value)
  },
  setFileDataArray({ commit }, value) {
    commit(types.SET_FILE_DATA_ARRAY, value)
  },
  async getSchemas({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getSchemas', () =>
      http.get('data/schemaNames')
    )
    commit(types.SET_SCHEMAS, r.data)
  },
  async getSchemaName({ commit, dispatch }, name) {
    const r = await startLoading(dispatch, 'getSchemaName', () =>
      http.get('data/schemaName', { params: { name } })
    )
    commit(types.SET_SCHEMA_COLUMNS, r.data)
  },
  async getTemplates({ commit }, schema) {
    const r = await http.get('data/schemaTemplates', {
      params: { schemaName: schema }
    })
    commit(types.SET_TEMPLATES, r.data)
  },
  async getMapping({ commit }, template) {
    const r = await http.get('data/schemaTemplate', { params: { name: template } })
    commit(types.SET_MAPPING, r.data)
  },
  async createTemplate({ commit, state, dispatch }, { schemaName, templateName, delimiter }) {
    await startLoading(dispatch, 'createTemplate', () =>
      http.post('data/saveSchema', {
        delimiter,
        schemaName,
        templateName
      })
    )
  },
  async updateTemplate({ commit, state, dispatch }) {
    await startLoading(dispatch, 'updateTemplate', () =>
      http.post('data/saveSchema', {
        id: state.mappingId,
        delimiter: state.delimiter,
        rowsToSkip: state.rowsToSkip,
        schemaName: state.schemaName,
        mappedData: state.mappedData,
        templateName: state.templateName,
        isSkipChecked: state.isSkipChecked,
        isSelectedData: state.isSelectedData
      })
    )
  },
  async checkImportData({ commit }, csv) {
    commit(types.SET_CSVDATA, csv)
    // const r = await startLoading(dispatch, 'checkImportData', () =>
    //   http.post('data/checkImportData', {
    //     csvData: JSON.stringify(csv),
    //     mappedFields: state.schemaColumns.map(i => i.value).join(','),
    //     templateName: state.templateName,
    //     corporateAccountId: state.corporateId
    //   })
    // )
    // commit(types.SET_ADDRESS_ERROR, r.data.error)
    // commit(types.SET_ADDRESS_APPROVED, r.data.approved)
    // commit(types.SET_ADDRESS_DUPLICATE, r.data.duplicate)
  },
  async uploadImportData({ commit, state, dispatch }, csv) {
    console.log('Upload Data', {
      schemaName: state.schemaName,
      csvData: JSON.stringify(csv),
      mappedFields: state.schemaColumns.map(i => i.value).join(','),
      templateName: state.templateName
    })
    // await startLoading(dispatch, 'uploadImportData', () =>
    //   http.post('data/uploadData', {
    //     schemaName: 'MultiShop',
    //     csvData: JSON.stringify(csv),
    //     mappedFields: state.schemaColumns.map(i => i.value).join(','),
    //     templateName: state.templateName
    //   })
    // )
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/import-data/actions.js